import { whatsappHref } from '@/lib/contactProtect';
interface SocialSidebarProps {
  lang?: 'en' | 'tr';
}

const LABEL = {
  en: 'Follow Us',
  tr: 'Bizi Takip Edin',
};

export default function SocialSidebar({ lang = 'en' }: SocialSidebarProps) {
  const label = LABEL[lang];

  const track = (platform: string) => {
    try {
      if (typeof window !== 'undefined' && (window as Window & { gtag?: (...args: unknown[]) => void }).gtag) {
        (window as Window & { gtag?: (...args: unknown[]) => void }).gtag!('event', 'social_sidebar_click', {
          event_category: 'social',
          event_label: platform,
          value: 1,
        });
      }
    } catch (_) { /* noop */ }
  };

  return (
    <div className="fixed left-0 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col items-center">
      {/* Vertical label */}
      <div
        className="mb-3 text-gray-500 text-[10px] font-bold uppercase tracking-[0.2em]"
        style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
      >
        {label}
      </div>

      {/* Thin line top */}
      <div className="w-px h-8 bg-gray-700 mb-1"></div>

      {/* Icons */}
      <div className="flex flex-col">
        <a
          href={whatsappHref()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('whatsapp_sidebar')}
          className="group w-10 h-10 flex items-center justify-center bg-gray-900/80 border-r border-t border-b border-gray-700 hover:bg-yellow-400 hover:border-yellow-400 transition-all duration-300 cursor-pointer"
          title="WhatsApp"
        >
          <i className="ri-whatsapp-fill text-gray-400 group-hover:text-black text-lg transition-colors"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/can-%C3%B6zen-8b15667/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('linkedin_sidebar')}
          className="group w-10 h-10 flex items-center justify-center bg-gray-900/80 border-r border-b border-gray-700 hover:bg-yellow-400 hover:border-yellow-400 transition-all duration-300 cursor-pointer"
          title="LinkedIn"
        >
          <i className="ri-linkedin-fill text-gray-400 group-hover:text-black text-lg transition-colors"></i>
        </a>
        <a
          href="https://www.instagram.com/csgtheeventcompany/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track('instagram_sidebar')}
          className="group w-10 h-10 flex items-center justify-center bg-gray-900/80 border-r border-b border-gray-700 hover:bg-yellow-400 hover:border-yellow-400 transition-all duration-300 cursor-pointer"
          title="Instagram"
        >
          <i className="ri-instagram-fill text-gray-400 group-hover:text-black text-lg transition-colors"></i>
        </a>
      </div>

      {/* Thin line bottom */}
      <div className="w-px h-8 bg-gray-700 mt-1"></div>
    </div>
  );
}
